import Vue from "vue";

import VeeValidate, { Validator } from "vee-validate";

import fr from "vee-validate/dist/locale/fr";

Validator.localize("fr", fr);
Vue.use(VeeValidate, {
  fieldsBagName: "formFields",
  inject: false,
});
